import { render } from "./TabBodyArchive.vue?vue&type=template&id=4af1cadf&scoped=true"
import script from "./TabBodyArchive.vue?vue&type=script&lang=js"
export * from "./TabBodyArchive.vue?vue&type=script&lang=js"

import "./TabBodyArchive.vue?vue&type=style&index=0&id=4af1cadf&scoped=true&lang=css"

import exportComponent from "/home/manohar/Bhutan_gitlab/tethysapp-airqualitybt/tethysapp/airqualitybt/vairqualitybt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af1cadf"]])

export default __exports__